module.exports = __webpack_public_path__ + "img/9.3d6e90cf.png";